export default class Roles {
	public static readonly User: string = "User";
	public static readonly Admin = "Admin";
	public static readonly DomainAdmin = "DomainAdmin";
}
